import { render, staticRenderFns } from "./Emulti.vue?vue&type=template&id=dff35bcc"
import script from "./Emulti.vue?vue&type=script&lang=js"
export * from "./Emulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports